export default __webpack_public_path__ + "static/LOGO-CTEDU-02-19337c40dfd4969c987d418f947b77f3.svg";